import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {ColorOption} from '../../../shared/models/appearance';
import {SwatchComponent} from '../swatch/swatch.component';
import {USER_SELECTABLE_COLORS} from '@shared/utils/color.util';

@Component({
  selector: 'motn-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SwatchComponent,
  ],
})
export class ColorPickerComponent implements OnInit {
  @Input() color: ColorOption;
  @Output() colorPicked$: EventEmitter<ColorOption> = new EventEmitter<ColorOption>();

  // Use centralized constant for user-selectable colors
  options: readonly ColorOption[] = USER_SELECTABLE_COLORS;

  constructor() {
  }

  ngOnInit(): void {
  }

  pick(color: ColorOption) {
    this.color = color;
    this.colorPicked$.next(color);
  }
}
